import React, { useEffect } from 'react'
import { useAppDispatch } from 'app/hooks'
import { useDashboardData, useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { useDashboardWidgetPreWork } from 'hooks/useWidgetState'
import { getMoreWidgetForDashboard } from 'features/widget/asyncThunks'
import { WidgetId } from 'features/types'
import { AudienceStreamWidget } from 'schemas/AudienceStreamWidgetSchema'
import { SocialWebStreamWidget } from 'schemas/SocialWebStreamWidgetSchema'
import { Dashboard } from 'schemas/DashboardSchema'
import { SentenceFingerprintRetrievalResult } from 'schemas/SentenceFingerprintRetrievalResultSchema'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'

import createSentenceSearch from './createSentenceSearch'

const SentenceSoundbiteSearchEffect = ({
  widgetId,
  fingerprintIndex,
  children
}: {
  widgetId: WidgetId
  fingerprintIndex: number
  children: React.ReactElement
}) => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebStreamWidget | AudienceStreamWidget>(
    widgetId
  )
  const dashboardData = useDashboardData() as Dashboard
  const preWork = useDashboardWidgetPreWork<SentenceFingerprintRetrievalResult>(widgetId)
  const { fingerprints } = preWork[0].results![0].data
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp(widgetId)

  useEffect(() => {
    const soundbiteSearch = createSentenceSearch(
      widgetSetting,
      dashboardData,
      fingerprints!,
      fingerprintIndex
    )

    dispatch(
      getMoreWidgetForDashboard({
        searches: [soundbiteSearch],
        widgetId: widgetSetting.widgetId!,
        timestamp: refreshTimestamp
      })
    )
  }, [widgetSetting, dashboardData, fingerprints, fingerprintIndex, dispatch, refreshTimestamp])

  return children
}

export default SentenceSoundbiteSearchEffect
